import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Colors } from '../../../../../colors';
import { mediaQueryMobileLimit } from '../../../../../utils/constants';

export const TopHeroStyled = {
  Container: styled(Grid) <any>`
    width: 100%;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.16);
  `,
  LogoAndDescriptionContainer: styled(Grid) <any>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;
    padding: 35px 0;
    padding-right: 100px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      align-items: center;
      padding-right: 0;
    }
  `,
  Logo: styled(Grid) <any>`
    margin-bottom: 11px;
    width: 243px;
    font-family: EncodeSans-Medium;
    color: #3579ba;
    font-size: 31px;
    font-weight: bold;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      width: auto;
     }
  `,
  Description: styled(Grid) <any>`
    font-family: EncodeSans-Medium;
    color: ${Colors.Primary};
    font-size: 16px;
    width: 243px;
    padding: 0 1px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      width: 220px;
      text-align: center;
     }
  `,

  TitlesContainer: styled(Grid) <any>`
    background-color: ${Colors.Primary};
    display: flex;
    justify-content: space-between;
    padding-right: 200px;
    padding-left: 110px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
     padding: 10px 0;
     } 
  `,
  TitleContainer: styled(Grid) <any>`
    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
  `,
  Title: styled.p <any>`
    font-family: EncodeSans-Medium;
    color: white;
    font-size: 16px;
    @media (max-width: ${mediaQueryMobileLimit}px) {
      font-size: 14px;
      } 
  `,
  svg: styled.div <any>`
   margin-bottom: 12px;
  `,
};
